export const TC_COLORS = {
  RED: '#b30303',
  YELLOW: '#E1C103',
  GREEN: '#008e00',
  BLUE: '#06cccc',
  PURPLE: '#FF25FF',
  DEFAULT: '#fff',
};

export const OTHER_COLORS = [
  '#54108d',
  '#6514aa',
  '#7a18ce',
  '#8229ce',
  '#995bce',
  '#a97dce',
  '#b189d2',
  '#ffff3f',
  '#eeef20',
  '#d4d700',
  '#bfd200',
  '#aacc00',
  '#80b918',
  '#55a630',
  '#2b9348',
  '#007f5f',
  '#14746f',
  '#248277',
  '#358f80',
  '#469d89',
  '#56ab91',
  '#67b99a',
  '#78c6a3',
  '#88d4ab',
  '#a9d6e5',
  '#89c2d9',
  '#61a5c2',
  '#468faf',
  '#2c7da0',
  '#012a4a',
  '#390000',
  '#530000',
  '#600000',
  '#740707',
  '#870d0d',
  '#9a1414',
  '#a21818',
  '#d42727',
  '#fa3434',
  '#ff9100',
  '#ff8500',
  '#ff7900',
  '#ff6d00',
  '#ff6000',
  '#ff5400',
  '#ff4800',
];

export const CATEGORIES_COLOR = [
  '#f94144',
  '#f3722c',
  '#f8961e',
  '#f9c74f',
  '#90be6d',
  '#43aa8b',
  '#4d908e',
  '#577590',
  '#277da1',
  '#013f58',
  '#005f73',
  '#0a9396',
  '#7bb09e',
  '#E76BED',
  '#CC07DE',
  '#A502C9',
  '#9E00A4',
  '#790384',
  '#650255',
];

export const BASE_COLOR = [
  '#3366cc',
  '#dc3912',
  '#ff9900',
  '#109618',
  '#990099',
  '#0099c6',
  '#dd4477',
  '#66aa00',
  '#b82e2e',
  '#316395',
  '#994499',
  '#22aa99',
  '#aaaa11',
  '#6633cc',
  '#e67300',
  '#8b0707',
  '#651067',
  '#329262',
  '#5574a6',
  '#3b3eac',
  '#b77322',
  '#16d620',
  '#b91383',
  '#f4359e',
  '#9c5935',
  '#a9c413',
  '#2a778d',
  '#668d1c',
  '#bea413',
  '#0c5922',
  '#743411',
  '#00ffff',
  '#8a2be2',
  '#e2e200',
  '#ff8a00',
  '#a52a2a',
  '#5f9ea0',
  '#7fff00',
  '#d2691e',
  '#6495ed',
  '#ff7f50',
  '#dc143c',
  '#008b8b',
  '#006400',
  '#ff8c00',
  '#9932cc',
  '#00ced1',
  '#9400d3',
  '#ff1493',
  '#ffd700',
  '#adff2f',
  '#ff69b4',
  '#4b0082',
  '#add8e6',
  '#f08080',
  '#800000',
  '#ba55d3',
  '#3cb371',
  '#7b68ee',
  '#00fa9a',
  '#48d1cc',
  '#c71585',
  '#191970',
  '#ffa500',
  '#ff4500',
  '#6b8e23',
  '#afeeee',
  '#db7093',
  '#ffdab9',
  '#b0e0e6',
  '#ff0000',
  '#bc8f8f',
  '#4169e1',
  '#8b4513',
  '#fa8072',
  '#f4a460',
  '#2e8b57',
  '#ffff00',
  '#f5deb3',
  '#ee82ee',
  '#177ad2',
  '#a2352b',
  '#af23bb',
  '#628808',
  '#de36db',
  '#32c624',
  '#3bd9f9',
  '#1646ea',
  '#ac7635',
  '#20b5d9',
  '#80f825',
  '#34af74',
  '#5d8fee',
  '#36098e',
  '#97ec1b',
  '#e8720b',
  '#6a0687',
  '#18e17a',
  '#4f2016',
  '#bcfc5f',
  '#117ba0',
  '#673f2c',
  '#207a90',
  '#d58bfe',
  '#ebe47b',
  '#ba111e',
  '#7de2f9',
  '#a62706',
  '#e1f113',
  '#5ca104',
  '#699de5',
  '#ffe28c',
  '#f6042d',
  '#3784ec',
  '#bfa412',
  '#820153',
  '#2b226a',
  '#2ba3a9',
  '#31c917',
  '#ced499',
  '#c2108d',
  '#6c07a4',
  '#d5dce6',
  '#5245d7',
  '#a44e63',
  '#a3b0b4',
  '#ef54a0',
  '#cb5e24',
  '#5ceccc',
  '#48e47b',
  '#e8b067',
  '#99ead5',
  '#5caa54',
  '#1d0bf7',
  '#dff948',
  '#a02ade',
  '#cbcd9a',
  '#7fcd1a',
  '#569a89',
  '#7c10cc',
  '#8ed59c',
  '#f2efb3',
  '#4cfb2a',
  '#afbe38',
  '#2fcdda',
  '#a09b9c',
  '#202db1',
  '#a743fd',
  '#9a9831',
  '#79fc89',
  '#e1f86e',
  '#f6ae2b',
  '#a9f2c4',
  '#26aa80',
  '#1c0cd3',
  '#f01c22',
  '#69741e',
  '#e74520',
  '#930db8',
  '#ebd588',
  '#63968c',
  '#e9ccf9',
  '#b93abf',
  '#fe263c',
  '#22411a',
  '#4854d2',
  '#cae438',
  '#31ac9b',
  '#b96bd6',
  '#910e32',
  '#7665a1',
  '#fdafe5',
  '#f4ab76',
  '#951b42',
  '#e58858',
  '#6b5cbc',
  '#904e4f',
  '#4774f7',
  '#9df173',
  '#cafcbb',
  '#4a839d',
  '#e60b0a',
  '#ad8027',
  '#107f46',
  '#b6a2e8',
  '#df7ea0',
  '#961efd',
  '#57fc5b',
  '#2e987c',
  '#84a1f6',
  '#da7449',
  '#b6d372',
  '#6b0e4b',
  '#562ad6',
  '#ebf83c',
  '#f8ba55',
  '#41ccdc',
  '#d4f030',
  '#7c90cd',
  '#ae8fb3',
  '#4aa5a0',
  '#23f70d',
  '#d1ecdc',
  '#bcb2f5',
  '#f9d302',
  '#3d2cf8',
  '#78291d',
  '#2ed08a',
  '#33e112',
  '#280c69',
  '#f04e02',
  '#5c1cb2',
  '#a5d2e1',
  '#604574',
  '#2766bb',
  '#ff1df6',
  '#19f5a7',
  '#ead4a9',
  '#31a6a3',
  '#e41c23',
  '#1899f9',
  '#d13d1f',
];

export const HOME_CHART_COLOR = {
  light: '#995bce',
  dark: '#a97dce',
  yellow: '#f0d60b',
  black: '#000',
  white: '#fff',
  pink1: '#790384',
  pink2: '#e76bed',
  investment: '#791ace',
};

export const COMPANY_COLORS = [
  '#3366cc',
  '#dc3912',
  '#ff9900',
  '#109618',
  '#990099',
  '#0099c6',
  '#dd4477',
  '#66aa00',
  '#b82e2e',
  '#316395',
  '#994499',
  '#22aa99',
  '#aaaa11',
  '#6633cc',
  '#e67300',
  '#8b0707',
  '#651067',
  '#329262',
  '#5574a6',
  '#3b3eac',
  '#b77322',
  '#16d620',
  '#b91383',
  '#f4359e',
  '#9c5935',
  '#a9c413',
  '#2a778d',
  '#668d1c',
  '#bea413',
  '#0c5922',
  '#743411',
  '#00ffff',
  '#8a2be2',
  '#e2e200',
  '#ff8a00',
  '#a52a2a',
  '#5f9ea0',
  '#7fff00',
  '#d2691e',
  '#6495ed',
  '#ff7f50',
  '#dc143c',
  '#008b8b',
  '#006400',
  '#ff8c00',
  '#9932cc',
  '#00ced1',
  '#9400d3',
  '#ff1493',
  '#ffd700',
  '#adff2f',
  '#ff69b4',
  '#4b0082',
  '#add8e6',
  '#f08080',
  '#800000',
  '#ba55d3',
  '#3cb371',
  '#7b68ee',
  '#00fa9a',
  '#48d1cc',
  '#c71585',
  '#191970',
  '#ffa500',
  '#ff4500',
  '#6b8e23',
  '#afeeee',
  '#db7093',
  '#ffdab9',
  '#b0e0e6',
  '#ff0000',
  '#bc8f8f',
  '#4169e1',
  '#8b4513',
  '#fa8072',
  '#f4a460',
  '#2e8b57',
  '#ffff00',
  '#f5deb3',
  '#ee82ee',
  '#177ad2',
  '#a2352b',
  '#af23bb',
  '#628808',
  '#de36db',
  '#32c624',
  '#3bd9f9',
  '#1646ea',
  '#ac7635',
  '#20b5d9',
  '#80f825',
  '#34af74',
  '#5d8fee',
  '#36098e',
  '#97ec1b',
  '#e8720b',
  '#6a0687',
  '#18e17a',
  '#4f2016',
  '#bcfc5f',
  '#117ba0',
  '#673f2c',
  '#207a90',
  '#d58bfe',
  '#ebe47b',
  '#ba111e',
  '#7de2f9',
  '#a62706',
  '#e1f113',
  '#5ca104',
  '#699de5',
  '#ffe28c',
  '#f6042d',
  '#3784ec',
  '#bfa412',
  '#820153',
  '#2b226a',
  '#2ba3a9',
  '#31c917',
  '#ced499',
  '#c2108d',
  '#6c07a4',
  '#d5dce6',
  '#5245d7',
  '#a44e63',
  '#a3b0b4',
  '#ef54a0',
  '#cb5e24',
  '#5ceccc',
  '#48e47b',
  '#e8b067',
  '#99ead5',
  '#5caa54',
  '#1d0bf7',
  '#dff948',
  '#a02ade',
  '#cbcd9a',
  '#7fcd1a',
  '#569a89',
  '#7c10cc',
  '#8ed59c',
  '#f2efb3',
  '#4cfb2a',
  '#afbe38',
  '#2fcdda',
  '#a09b9c',
  '#202db1',
  '#a743fd',
  '#9a9831',
  '#79fc89',
  '#e1f86e',
  '#f6ae2b',
  '#a9f2c4',
  '#26aa80',
  '#1c0cd3',
  '#f01c22',
  '#69741e',
  '#e74520',
  '#930db8',
  '#ebd588',
  '#63968c',
  '#e9ccf9',
  '#b93abf',
  '#fe263c',
  '#22411a',
  '#4854d2',
  '#cae438',
  '#31ac9b',
  '#b96bd6',
  '#910e32',
  '#7665a1',
  '#fdafe5',
  '#f4ab76',
  '#951b42',
  '#e58858',
  '#6b5cbc',
  '#904e4f',
  '#4774f7',
  '#9df173',
  '#cafcbb',
  '#4a839d',
  '#e60b0a',
  '#ad8027',
  '#107f46',
  '#b6a2e8',
  '#df7ea0',
  '#961efd',
  '#57fc5b',
  '#2e987c',
  '#84a1f6',
  '#da7449',
  '#b6d372',
  '#6b0e4b',
  '#562ad6',
  '#ebf83c',
  '#f8ba55',
  '#41ccdc',
  '#d4f030',
  '#7c90cd',
  '#ae8fb3',
  '#4aa5a0',
  '#23f70d',
  '#d1ecdc',
  '#bcb2f5',
  '#f9d302',
  '#3d2cf8',
  '#78291d',
  '#2ed08a',
  '#33e112',
  '#280c69',
  '#f04e02',
  '#5c1cb2',
  '#a5d2e1',
  '#604574',
  '#2766bb',
  '#ff1df6',
  '#19f5a7',
  '#ead4a9',
  '#31a6a3',
  '#e41c23',
  '#1899f9',
  '#d13d1f',
];

export const PACKAGE_COLOR = [
  {
    index: 0,
    className: 'white',
  },
  {
    index: 1,
    className: 'yellow',
  },
  {
    index: 2,
    className: 'purple',
  },
  {
    index: 3,
    className: 'black',
  },
];

export const LIVE_CHART_COLOR = [
  '#D9ED92',
  '#B5E48C',
  '#99D98C',
  '#76C893',
  '#52B69A',
  '#34A0A4',
  '#168AAD',
  '#1A759F',
  '#1E6091',
  '#184E77',
  '#FFBA08',
  '#FAA307',
  '#F48C06',
  '#E85D04',
  '#DC2F02',
  '#D00000',
  '#9D0208',
];
